/**
 * Evaluation windows (in complete days) selectable for deriving the
 * recommended daily budget from the aMER/MER target. Shared by Financial
 * Settings and the Budget Recommender so both pages offer the same choices.
 */
export const DAILY_BUDGET_EVAL_PERIODS = [1, 3, 7] as const

export const DEFAULT_DAILY_BUDGET_EVAL_PERIOD = 7

export const DAILY_BUDGET_EVAL_PERIOD_OPTIONS = DAILY_BUDGET_EVAL_PERIODS.map(
  d => ({
    value: d as number,
    label: d === 1 ? "Last complete day" : `Last ${d} complete days`,
  }),
)
